import * as TABLE from 'constant/action/table'
import { handleActions } from 'redux-actions'
import { ARTICLE, ATTACHMENTS, CATEGORY_COLUMNS, COLUMNS, DATASET, DISCOVERY, INSIGHT, WEBPAGE, USER_COLUMNS, SITE_COLUMNS, TAG_COLUMNS, ORDER_CATEGORIES } from 'constant/table'
import { articleColumns, discoveryColumns, datasetColumns, insightColumns, webpageColumns, attachmentColumns, orderCategoriesColumns } from 'view/component/table-columns'
import { categoryColumns } from 'view/page/category-management/component/table/component/columns'
import { tagColumns } from 'view/page/tag-management/component/table/component/columns'
import { siteColumns } from 'view/page/site-management/component/table/component/columns'
import { userColumns } from 'view/page/user-management/component/table/component/columns'
import _ from 'lodash'

const initialState = {
  columns: {
    [ARTICLE]: _.cloneDeep(COLUMNS[ARTICLE]),
    [ATTACHMENTS]: _.cloneDeep(COLUMNS[ATTACHMENTS]),
    [CATEGORY_COLUMNS]: _.cloneDeep(COLUMNS[CATEGORY_COLUMNS]),
    [DATASET]: _.cloneDeep(COLUMNS[DATASET]),
    [DISCOVERY]: _.cloneDeep(COLUMNS[DISCOVERY]),
    [INSIGHT]: _.cloneDeep(COLUMNS[INSIGHT]),
    [ORDER_CATEGORIES]: _.cloneDeep(COLUMNS[ORDER_CATEGORIES]),
    [SITE_COLUMNS]: _.cloneDeep(COLUMNS[SITE_COLUMNS]),
    [TAG_COLUMNS]: _.cloneDeep(COLUMNS[TAG_COLUMNS]),
    [USER_COLUMNS]: _.cloneDeep(COLUMNS[USER_COLUMNS]),
    [WEBPAGE]: _.cloneDeep(COLUMNS[WEBPAGE])
  },
  hiddenColumns: {
    [ARTICLE]: {},
    [CATEGORY_COLUMNS]: {},
    [DATASET]: {},
    [DISCOVERY]: {},
    [INSIGHT]: {},
    [ORDER_CATEGORIES]: {},
    [SITE_COLUMNS]: {},
    [TAG_COLUMNS]: {},
    [USER_COLUMNS]: {},
    [WEBPAGE]: {}
  },
  showSubTable: { category: {}, show: false, sub_categories: [] },
  shownColumns: {
    [ARTICLE]: { ...articleColumns },
    [ATTACHMENTS]: { ...attachmentColumns },
    [CATEGORY_COLUMNS]: { ...categoryColumns },
    [DATASET]: { ...datasetColumns },
    [DISCOVERY]: { ...discoveryColumns },
    [INSIGHT]: { ...insightColumns },
    [ORDER_CATEGORIES]: { ...orderCategoriesColumns },
    [SITE_COLUMNS]: { ...siteColumns },
    [TAG_COLUMNS]: { ...tagColumns },
    [USER_COLUMNS]: { ...userColumns },
    [WEBPAGE]: { ...webpageColumns }
  }
}

/* eslint-disable complexity */
const returnColumns = (actionPayload) => {
  switch (actionPayload) {
    case ARTICLE:
      return { ...articleColumns }
    case CATEGORY_COLUMNS:
      return { ...categoryColumns }
    case SITE_COLUMNS:
      return { ...siteColumns }
    case TAG_COLUMNS:
      return { ...tagColumns }
    case DATASET:
      return { ...datasetColumns }
    case DISCOVERY:
      return { ...discoveryColumns }
    case INSIGHT:
      return { ...insightColumns }
    case WEBPAGE:
      return { ...webpageColumns }
    case ATTACHMENTS:
      return { ...attachmentColumns }
    default:
      return { ...userColumns }
  }
}

export default handleActions({
  [TABLE.UPDATE_COLUMNS]: (state, action) => ({
    ...state,
    columns: action.payload
  }),
  [TABLE.UPDATE_SHOWN_COLUMNS]: (state, action) => ({
    ...state,
    shownColumns: action.payload
  }),
  [TABLE.UPDATE_HIDDEN_COLUMNS]: (state, action) => ({
    ...state,
    hiddenColumns: action.payload
  }),
  [TABLE.RESET_COLUMNS]: (state, action) => ({
    columns: {
      ...state.columns,
      [action.payload]: _.cloneDeep(COLUMNS[action.payload])
    },
    hiddenColumns: {
      ...state.hiddenColumns,
      [action.payload]: {}
    },
    shownColumns: {
      ...state.shownColumns,
      [action.payload]: returnColumns(action.payload)
    }
  }),
  [TABLE.UPDATE_SHOW_SUB_TABLE]: (state, action) => ({
    ...state,
    showSubTable: action.payload
  })
}, initialState)
